import React, { Component } from 'react';
import { actions } from 'react-redux-form';
import { connect } from 'react-redux';
import Select from 'react-select';

import 'react-select/dist/react-select.css';

class DropDown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value
    }
  }

  componentDidMount() {
    const { model, dispatch } = this.props;
    const val = this.props.value;

    if (val == null) {
      dispatch(actions.change(model, ''));
    } else if (val && val.value) {
      dispatch(actions.change(model, val.value));
    } else {
      dispatch(actions.change(model, val));
    }

    this.setState({ value: this.props.value });
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value != nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }

  handleChange(val) {
    const { model, dispatch } = this.props;

    this.setState({value: val}, () => {
      if (val === null) {
        dispatch(actions.change(model, ''));
      } else {
        dispatch(actions.change(model, val.value));
      }

      if (typeof this.props.onChange === 'function') {
        this.props.onChange(val);
      }
    });
  }

  render() {
    const { data, placeholder } = this.props;
    const searchable = this.props.searchable || false;
    
    return (
      <Select placeholder={placeholder}
              value={this.state.value}
              options={data}
              onChange={(option) => this.handleChange(option)}
              multi={false}
              searchable={searchable}
              className={this.props.className || ''}
      />
    )
  }
}

export default connect()(DropDown);



// WEBPACK FOOTER //
// ./src/components/common/form/dropdown.jsx